import React from 'react';
import { Edit, useRecordContext } from 'react-admin';
import UserForm from './UserForm';

const Title = () => {
  const record = useRecordContext();
  return <span>{record ? `Edit User: ${record.username}` : 'Edit User'}</span>;
};

const UserEdit = () => {
  const transform = (data) => {
    if (data.password) {
      return { ...data };
    }
    const { password, ...rest } = data;
    return rest;
  };

  return (
    <Edit transform={transform} title={<Title />}>
      <UserForm isEdit />
    </Edit>
  );
};

export default UserEdit;
